import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';
import Button from '../Common/Button';

const DonutChart = ({ data, onSliceClick, "data-testid": dataTestId = "donut-chart" }) => {

    // ✅ Custom label renderer (centered inside slice)
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
        if (percent === 0) return null; // Hide label when percent is 0

        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text
                x={x}
                y={y}
                fill="#ffffff"
                textAnchor="middle"
                dominantBaseline="central"
                fontSize="14"
                fontWeight="bold"
            >
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };

    const CustomLegend = (props) => {
        const { payload } = props;

        return (
            <ul className="flex flex-row items-start justify-center gap-6 mt-4 text-nowrap">
                {payload.map((entry, index) => {
                    const swatch = (
                        <span
                            className="inline-block w-2 h-2 rounded-full mr-2"
                            style={{ backgroundColor: entry.color }}
                        />
                    );

                    return (
                        <li key={`item-${index}`} className="flex items-center text-xs text-gray-700 dark:text-white">
                            {onSliceClick ? (
                                <Button
                                    onClick={() => onSliceClick(entry.payload)}
                                    className="flex items-center cursor-pointer"
                                    data-testid={`donut-legend-item-${entry.value}`}
                                >
                                    {swatch}
                                    {entry.value}
                                </Button>
                            ) : (
                                <>
                                    {swatch}
                                    {entry.value}
                                </>
                            )}
                        </li>
                    );
                })}
            </ul>
        );
    };

    const CustomTooltip = ({ active, payload }) => {
        if (!active || !payload || !payload.length) return null;

        const item = payload[0]; // Pie chart has only one hovered item
        return (
            <div className="rounded-lg px-4 py-3 shadow-md text-xs font-semibold text-white bg-[#1E555C]">
                <div className="flex justify-between gap-2">
                    <span>{item?.name}:</span>
                    <span>{item?.value} Units</span>
                </div>
            </div>
        );
    };

    return (
        <div className="w-full h-[300px] md:h-full" data-testid={dataTestId}>
            <ResponsiveContainer width="100%" height="100%" tabIndex={-1}>
                <PieChart>
                    <Pie
                        data={data}
                        cx="50%"
                        cy="50%"
                        innerRadius={50}
                        outerRadius={105}
                        dataKey="value"
                        labelLine={false}
                        label={renderCustomizedLabel}
                        stroke="none"
                        onClick={(entry) => onSliceClick?.(entry?.payload)}
                    >
                        {data?.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} stroke="none" className={onSliceClick ? 'cursor-pointer' : undefined} />
                        ))}
                    </Pie>
                    <Tooltip content={<CustomTooltip />} />
                    <Legend
                        verticalAlign="bottom"
                        iconType="circle"
                        content={CustomLegend}
                        formatter={(value) => <span className="text-xs  text-gray-700">{value}</span>}
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};

export default DonutChart;
